import React from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  placeholder = "Search Dataset",
  onChange,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex h-12 w-[280px] items-center gap-3 rounded-none border border-brand-border bg-brand-bg px-4 transition-colors focus-within:border-brand-accent",
        className
      )}
    >
      <Search className="shrink-0 text-brand-muted" size={16} />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        className="w-full border-none bg-transparent text-[14px] text-brand-text placeholder:text-brand-muted focus:outline-none"
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
